export class TripItemType {
  public name = '';

  public code = '';
}
